import { render, staticRenderFns } from "./TenantInvoice.vue?vue&type=template&id=a80c809e&scoped=true"
import script from "./TenantInvoice.vue?vue&type=script&lang=js"
export * from "./TenantInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80c809e",
  null
  
)

export default component.exports